import moment from 'moment';

export default function durationToString(duration) {
  if (!moment.isDuration(duration)) {
    throw new Error('Argument is not a valid moment duration');
  }

  switch (true) {
    case duration.years() > 1:
      return `${duration.years()} Jahren`;
    case duration.years() > 0:
      return 'einem Jahr';
    case duration.months() > 1:
      return `${duration.months()} Monaten`;
    case duration.months() > 0:
      return 'einem Monat';
    case duration.weeks() > 1:
      return `${duration.weeks()} Wochen`;
    case duration.weeks() > 0:
      return 'einer Woche';
    case duration.days() > 1:
      return `${duration.days()} Tagen`;
    case duration.days() > 0:
      return 'einem Tag';
    case duration.hours() > 1:
      return `${duration.hours()} Stunden`;
    case duration.hours() > 0:
      return 'einer Stunde';
    case (duration.minutes() > 1):
      return `${duration.minutes()} Minuten`;
    case (duration.minutes() > 0):
      return 'einer Minute';
    case (duration.seconds() > 1):
      return `${duration.seconds()} Sekunden`;
    case (duration.seconds() > 0):
      return 'einer Sekunde';
    default:
      return 'weniger als einer Sekunde';
  }
}
